import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        let variableCopy = parsedParameters['variableObject'];
        if(parsedParameters.error){
            variableCopy[variableName] = {
                error : {
                    message : 'Failed to parse function parameters.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let resolvedParams = parsedParameters['accumulator'];
        let data = resolvedParams['data'];
        let mimeType = resolvedParams['mimeType'];

        if(data === undefined || data === null || data === ''){
            variableCopy[variableName] = {
                error : {
                    message : 'Invalid data parameter.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Invalid data parameter.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!mimeType){
            variableCopy[variableName] = {
                error : {
                    message : 'Invalid MIME type parameter.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Invalid MIME type parameter.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }
        
        const dataUrlMatch = data.match(/^data:([^;]+);base64,/);
        const isBase64 = dataUrlMatch || 
        (/^[A-Za-z0-9+/=]+$/.test(data) && data.length % 4 === 0);
        let blobData;
        
        if (isBase64) {
            // For base64: use detected MIME type from data URL, then provided parameter, then default
            const detectedMimeType = dataUrlMatch ? dataUrlMatch[1] : null;
            const finalMimeType = detectedMimeType || mimeType;
            
            // Remove data URL prefix if present
            const base64Data = data.includes(',') ? data.split(',')[1] : data;
            
            // Convert base64 to binary
            const byteCharacters = atob(base64Data);
            const byteArray = new Uint8Array(byteCharacters.length);
            
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
            }
            
            blobData = new Blob([byteArray], { type: finalMimeType });
        }
        
        if(!blobData){
            // For plain text
            const finalMimeType = mimeType || 'text/plain';
            blobData = new Blob([data], { type: finalMimeType });
        }

        variableCopy[variableName] = blobData;
        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy,
            hasError : false,
            errorPayload : undefined
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/convertToBlobParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}